@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<div class="table-options search-display">
  <mat-form-field appearance="fill">
    <mat-label>Search</mat-label>
    <input matInput #searchInput />
  </mat-form-field>
  <button mat-raised-button color="primary" aria-label="Search" (click)="onSearch(searchInput.value)">
    {{ 'Global.Search' | translate }}
  </button>
</div>
@if (results?.length) {
  <div class="content-body container mt-1">
    <mat-accordion class="mt-1 faq-accordion">
      @for (element of results; track element; let i = $index) {
        <mat-expansion-panel (opened)="loadContent(element, i)" (closed)="emptyContent(element, i)">
          <mat-expansion-panel-header>
            @if (element?.name) {
              <mat-panel-title>
                {{ element?.name[translate.currentLang] }}
              </mat-panel-title>
            }
            @if (element.type) {
              <mat-panel-description class="panel-desc">
                {{ 'Search.Types.' + element.type | translate }}
                <!--  <button
                mat-icon-button
                color="primary"
                (click)="openInNewTab(element)"
                >
                <mat-icon>open_in_new</mat-icon>
              </button> -->
                <button mat-icon-button color="primary" (click)="visualizeContent(element)">
                  <mat-icon>library_books</mat-icon>
                </button>
              </mat-panel-description>
            }
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div class="content-style" [innerHTML]="element?.content"></div>
            @if (element?.description) {
              <mat-label>{{ element?.description[translate.currentLang] }}</mat-label>
            }
            <div class="content-actions">
              <button mat-raised-button color="primary" [disabled]="element.alreadyAdded" (click)="selectElement(element)">
                {{ 'Global.Choose' | translate }}
              </button>
            </div>
          </ng-template>
        </mat-expansion-panel>
      }
      <app-custom-paginator [pageSizeOptions]="pageSizeOptions" [totalLength]="totalSize" (page)="onPageChange($event)" [type]="'searcher'" [(currentPage)]="pageIndex"></app-custom-paginator>
    </mat-accordion>
  </div>
}
@if (!results?.length && !preFirstSearch) {
  <div class="content-body container mt-1">
    {{ 'Search.NoResultFound' | translate }}
  </div>
}
